import React from "react";
import { Link } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTwitter,
  faLinkedin,
  faYoutube,
  faInstagram,
} from "@fortawesome/free-brands-svg-icons";

const socialLinks = [
  {
    label: "X / Twitter",
    href: "https://x.com/testimonialshub",
    icon: faTwitter,
  },
  {
    label: "LinkedIn",
    href: "https://www.linkedin.com/company/testimonialshub",
    icon: faLinkedin,
  },
  {
    label: "YouTube",
    href: "https://www.youtube.com/@testimonialshub",
    icon: faYoutube,
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/testimonialshub/",
    icon: faInstagram,
  },
];

const productLinks = [
  { label: "Product", href: "/#product" },
  { label: "Features", to: "/features" },
  { label: "Pricing", to: "/pricing" },
  { label: "Wall of Love", href: "/#examples" },
  { label: "Video Testimonials", to: "/features" },
];

const resourceLinks = [
  { label: "Resources", to: "/resources" },
  { label: "Integrations", href: "/resources#integrations" },
  { label: "Case Studies", href: "/resources#case-studies" },
  { label: "Support", href: "/resources#support" },
  { label: "FAQ", href: "/#faq" },
];

const legalLinks = [
  { label: "Privacy Policy", to: "/privacy-policy" },
  { label: "Terms & Conditions", to: "/terms-and-conditions" },
  { label: "Refund Policy", to: "/refund-policy" },
];

function FooterLink({ item }) {
  const className = "text-sm text-white/80 hover:text-white transition";

  if (item.to) {
    return (
      <Link to={item.to} className={className}>
        {item.label}
      </Link>
    );
  }

  return (
    <a href={item.href} className={className}>
      {item.label}
    </a>
  );
}

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-pink-500 via-purple-500 to-orange-500 text-white">
      <div className="container mx-auto px-6 py-12">
        <div className="grid gap-10 md:grid-cols-[1.5fr_1fr_1fr_1fr]">
          <div>
            <Link
              to="/"
              className="inline-block text-3xl font-extrabold text-white drop-shadow"
            >
              TestimonialsHub
            </Link>
            <p className="mt-3 max-w-sm text-sm leading-6 text-white/85">
              Collect text and video testimonials, approve the best stories,
              and publish beautiful Wall of Love widgets on any website.
            </p>

            <div className="mt-6 flex gap-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noreferrer"
                  aria-label={social.label}
                  className="flex h-10 w-10 items-center justify-center rounded-full bg-white/15 text-white transition hover:bg-white hover:text-pink-600"
                >
                  <FontAwesomeIcon icon={social.icon} />
                </a>
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-white">Product</h3>
            <div className="flex flex-col gap-3">
              {productLinks.map((item) => (
                <FooterLink key={item.label} item={item} />
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-white">Resources</h3>
            <div className="flex flex-col gap-3">
              {resourceLinks.map((item) => (
                <FooterLink key={item.label} item={item} />
              ))}
            </div>
          </div>

          <div>
            <h3 className="mb-4 font-bold text-white">Company</h3>
            <div className="flex flex-col gap-3">
              {legalLinks.map((item) => (
                <FooterLink key={item.label} item={item} />
              ))}
              <a
                href="mailto:support@testimonialshub.com"
                className="text-sm text-white/80 hover:text-white transition"
              >
                support@testimonialshub.com
              </a>
            </div>
          </div>
        </div>

        <div className="mt-10 flex flex-col gap-3 border-t border-white/20 pt-6 text-sm text-white/75 md:flex-row md:items-center md:justify-between">
          <p>© {new Date().getFullYear()} TestimonialsHub. All rights reserved.</p>
          <p>Built for founders, agencies, creators, and growing SaaS teams.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
